import { enums } from "../enums/index";

export const CertificateWithSecretVersionTypes = [
  enums.SmartContractVersion.EWC, enums.SmartContractVersion.VOLTA, enums.SmartContractVersion.TOBALABA, enums.SmartContractVersion.V3
];


// WEBPACK FOOTER //
// ./src/constants/CertificateWithSecretVersionTypes.js